<!--  -->
<template>
  <section class="study-progress">
    <h1 class="study-title">
      <img
        src="../../../assets/img/personalImg/personalIcon01.png"
        alt=""
      /><span>成长记录</span>
      <img
        v-if="!showShare"
        @click="instrucTionsOpen"
        src="../../../assets/img/learningGuidePage/reporttip.png"
        alt=""
      >
    </h1>

    <div class="study-info">
      <div class="study-info-center">
        <div>
          <h3>累计学习</h3>
          <p>
            <span>{{ studyInfo.learnDays || 0 }}</span>days
          </p>
          <img
            class="bgImg"
            src="../../../assets/img/personalImg/personalIcon02.png"
            alt=""
          />
        </div>
        <p>再接再厉哟</p>
      </div>
      <div class="study-info-center">
        <div>
          <h3>学习时长</h3>
          <p>
            <span>{{ studyInfo.learnTime || 0 }}</span>min

          </p>
          <img
            class="bgImg"
            src="../../../assets/img/learningGuidePage/reportleft2.png"
            alt=""
          />
        </div>
        <p>超过了全国{{newPercent}}％的学员</p>
      </div>
    </div>
    <div class="study-card">
      <template v-if="JSON.stringify(studyInfo)!=='{}'">
        <div v-if="studyInfo.liveNumber">
          <h4>直播课</h4>
          <p>
            <span>{{ studyInfo.finishLiveNumber }}</span>/{{ studyInfo.liveNumber }}
          </p>
        </div>
        <div v-if="studyInfo.videoNumber">
          <h4>录播课</h4>
          <p>
            <span>{{ studyInfo.finishVideoNumber }}</span>/{{ studyInfo.videoNumber }}
          </p>
        </div>
        <div>
          <h4>电子书</h4>
          <p>
            <span>{{ (studyInfo.ebookProgress*100) ? (studyInfo.ebookProgress*100).toFixed(2) : 0 }}</span>%
          </p>
        </div>
        <div v-if="studyInfo.questionAnswerTimes !== -1">
          <h4>答疑</h4>
          <p>
            <span>{{ studyInfo.questionAnswerTimes }}</span>次
          </p>
        </div>
        <div v-if="studyInfo.daKaTimes !== -1">
          <h4>打卡</h4>
          <p>
            <span>{{ studyInfo.daKaTimes }}</span>次
          </p>
        </div>
        <div v-if="studyInfo.examNum">
          <h4>考试</h4>
          <p>
            <span>{{ studyInfo.examNum }}</span>次
          </p>
        </div>
        <div v-if="studyInfo.correctNum!==-1">
          <h4>批改</h4>
          <p>
            <span>{{ studyInfo.correctNum }}</span>次
          </p>
        </div>
      </template>
    </div>

    <InstructionsPop
      v-if="popShow"
      :contentInstructions="contentInstructions"
      :personalSource='true'
      @popClose="popClose"
    />
  </section>
</template>

<script>
import InstructionsPop from '@/pages/learningGuidePage/evaluation/instructionsPop.vue';

export default {
  components: {
    InstructionsPop,
  },
  data() {
    return {
      popShow: false,
      // 学习进度说明弹窗
      contentInstructions: [
        '1. 累计学习：累计学习天数之和。',
        '2. 学习时长：所有课程累计观看时长之和。',
        '3. 课程完成规则：直播课/直播回放或录播课观看时长至少占每节课总时长80%。离线播放会在下一次联网时自动同步进度。',
        '4. 电子书：统计为电子书的总学习进度。',
        '5. 答疑、打卡、考试、批改均为APP平台提交的总次数。',
        '6. 学习时长：直播、回放、录播的观看时长;重复观看会重复计算时长。',
      ],

    };
  },
  props: {
    studyInfo: {
      type: Object,
      default: () => { },
    },
    showShare: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    newPercent() {
      const percent = parseFloat(((this.studyInfo.beatRate || 0) * 100).toFixed(2));
      return percent;
    },
  },
  watch: {},
  methods: {
    instrucTionsOpen() {
      this.popShow = true;
    },
    popClose() {
      this.popShow = false;
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.study-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 45px;
  img {
    width: 29px;
    height: 29px;
  }
  span {
    padding: 0 14px 0 5px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
  }
}
.study-progress {
  width: 678px;
  margin: 0 auto;
  padding: 36px 33px 0 33px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.02);
  .study-info {
    display: flex;
    justify-content: space-between;
    padding-bottom: 50px;
    .study-info-center {
      > div {
        position: relative;
        width: 297px;
        height: 127px;
        background: #fff6ec;
        border-radius: 14px 14px 0 0;
        h3 {
          padding: 18px 0 14px 24px;
          color: #333;
          font-weight: 500;
          font-size: 25px;
          line-height: 36px;
        }
        p {
          padding-left: 25px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          span {
            padding: 0 2px;
            color: #ff7f41;
            font-weight: 500;
            font-size: 40px;
            vertical-align: -2px;
          }
        }
        .bgImg {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 145px;
          height: 127px;
        }
      }
      > p {
        width: 100%;
        height: 40px;
        padding-left: 24px;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
        line-height: 40px;
        background: linear-gradient(270deg, rgba(255, 127, 65, 0.5) 0%, #ff7f41 100%);
        border-radius: 0 0 14px 14px;
      }
    }
  }
  .study-card {
    display: flex;
    flex-wrap: wrap;
    > div {
      position: relative;
      width: 202px;
      margin-bottom: 50px;
      text-align: center;
      h4 {
        padding-bottom: 20px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 18px;
      }
      p {
        color: #333;
        font-weight: 400;
        font-size: 25px;
        span {
          padding-right: 2px;
          color: #ff7f41;
          font-weight: 500;
          font-size: 50px;
        }
      }
    }
    > div::before {
      position: absolute;
      top: 15px;
      left: 0;
      width: 2px;
      height: 36px;
      background: #d8d8d8;
      content: '';
    }
    > div:nth-of-type(1)::before,
    > div:nth-of-type(4)::before {
      content: none;
    }
  }
}
</style>
